import React from 'react';
import {Modal, Button, Form, ButtonGroup} from 'react-bootstrap';

const MobileCheckboxPopup = ({showPopup, onClose, title, items, handleChecked, onSelectNone, onSelectAll}) => {
  return (
    <Modal show={showPopup} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='model-checkbox d-flex flex-column careers-modal-mobile' style={{maxHeight: 'calc(100vh)', overflow: 'auto'}}>
          <ul className='list-unstyled flex-shrink mb-0' style={{overflow: 'auto'}}>
            {items.map((i) => (
              <li key={i.id}>
                <Form.Group className='dropdown-item' controlId={i.id}>
                  <Form.Check type='checkbox' label={i.label} checked={i.checked} onChange={(e) => handleChecked(i.id, e)} />
                </Form.Group>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={'model-btn'}>
          <Button variant='link' onClick={onSelectNone}>
            נקה הכל
          </Button>
          <Button variant='link' onClick={onSelectAll}>
            בחר
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MobileCheckboxPopup;
